import type { NavLink, SiteConfig } from '@/types'

import { getOrigin } from '@/lib/window'
import { media } from '@/constants/media'

export const siteConfig: SiteConfig = {
    name: "Zaki Hatta",
    description: "Zaki Hatta is a software engineer from Padang, Indonesia, building fast web platforms, real-time GIS systems and mobile apps.",
    url: getOrigin(),
    ogImage: media.ogImage
}

export const profile = {
    fullName: "Zaki Hatta",
    role: "Software Engineer",
    location: "Padang, Indonesia",
    email: "zakihattamg@gmail.com",
    linkedin: 'https://www.linkedin.com/in/zaki-hatta',
    github: 'https://github.com/zakihatta'
}

export const primaryLinks: NavLink[] = [
    { label: "Work", href: '/work' },
    { label: "About", href: '/about' },
    { label: "Journal", href: '/journal' },
    { label: "Contact", href: '/contact' }
]

export const footerLinks: NavLink[] = [
    { label: "Work", href: '/work' },
    { label: "About", href: '/about' },
    { label: "Journal", href: '/journal' }
]

export const socialLinks: NavLink[] = [
    { label: "LinkedIn", href: profile.linkedin },
    { label: "GitHub", href: profile.github },
    { label: "Email", href: `mailto:${profile.email}` }
]

export const legalLinks: NavLink[] = [
    { label: "Terms of use", href: '/legal/terms-of-use' },
    { label: "Privacy policy", href: '/legal/privacy-policy' },
    { label: "Cookies", href: '/legal/cookies' }
]
